import React, { useState, useEffect } from "react"
import { Section, Box, Link } from "@quarkly/widgets"
import { Override } from "@quarkly/components"
import * as Components from "components"
import translations from "../translations"

const Header = ({
  lang: controlledLang,
  setLang: controlledSetLang,
  ...props
}) => {
  const [localLang, setLocalLang] = useState("en")

  useEffect(() => {
    const savedLang = localStorage.getItem("lang")
    if (savedLang) {
      setLocalLang(savedLang)
    }
  }, [])

  // Use controlled prop if provided, otherwise fallback to local state
  const currentLang = controlledLang || localLang

  const handleSetLang = newLang => {
    localStorage.setItem("lang", newLang)
    setLocalLang(newLang)
    if (controlledSetLang) {
      controlledSetLang(newLang)
    }
    window.dispatchEvent(new Event("languagechange"))
  }

  useEffect(() => {
    const syncLang = () => {
      const savedLang = localStorage.getItem("lang")
      if (savedLang && savedLang !== localLang) {
        setLocalLang(savedLang)
      }
    }
    window.addEventListener("languagechange", syncLang)
    return () => window.removeEventListener("languagechange", syncLang)
  }, [localLang])

  const t = translations[currentLang].nav

  return (
    <Section
      padding="16px 40px 16px 40px"
      quarkly-title="Header"
      position="fixed"
      top="0"
      left="0"
      width="100%"
      transition="background 0.3s ease"
      sm-padding="16px 20px 16px 20px"
      z-index="100"
      background="rgba(255, 255, 255, 0.85)"
      {...props}
    >
      <Override
        slot="SectionContent"
        flex-direction="row"
        align-items="center"
        display="flex"
        justify-content="space-between"
        width="100%"
        max-width="none"
      />
      <Box
        empty-border-color="LightGray"
        width="30%"
        align-items="center"
        lg-width="50%"
        empty-min-height="64px"
        empty-border-style="solid"
        display="flex"
        sm-width="70%"
        empty-min-width="64px"
        empty-border-width="1px"
        color="--dark"
      >
        <Components.Logo />
      </Box>
      <Box
        sm-width="30%"
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-style="solid"
        display="flex"
        align-items="center"
        empty-border-width="1px"
        empty-border-color="LightGray"
        width="70%"
        lg-width="50%"
      >
        <Components.QuarklycommunityKitMobileSidePanel
          z-index="101"
          menuPosition="near"
        >
          <Override
            slot="Wrapper"
            background="transparent"
            md-position="fixed"
            md-top="0"
            md-left="0"
            md-width="100vw"
            md-height="100vh"
            md-z-index="100"
          />
          <Override
            slot="Content"
            background="transparent"
            md-background="rgba(255, 255, 255, 0.85)"
            md-backdrop-filter="blur(1px)"
            md-position="fixed"
            md-top="0"
            md-left="0"
            md-z-index="99"
            md-width="100%"
            md-height="100%"
            md-display="flex"
            md-flex-direction="column"
            md-justify-content="center"
            md-align-items="center"
            md-padding="0"
          />
          <Override
            slot="Button"
            data-custom-hamburger="closed"
            md-z-index="101"
            md-position="relative"
            md-padding="0"
          />
          <Override slot="Button :open" data-custom-hamburger="open" />
          <Override slot="Button Icon" display="none" />
          <Override slot="Cross" display="none" />
          <Override slot="Button Text" display="none" />
          <Box
            md-padding="0"
            display="flex"
            justify-content="flex-end"
            align-items="center"
            md-flex-direction="column"
            md-justify-content="center"
            md-height="100%"
            md-grid-gap="30px"
          >
            <Link
              color="--darkL2"
              font="--base"
              margin="0px 0px 0px 20px"
              md-margin="0"
              md-font="normal 400 24px/1.2 --fontFamily-googlePoppins"
              href="/#approach"
              text-decoration-line="initial"
            >
              {t.approach}
            </Link>
            <Link
              color="--darkL2"
              font="--base"
              margin="0px 0px 0px 20px"
              md-margin="0"
              md-font="normal 400 24px/1.2 --fontFamily-googlePoppins"
              href="/#services"
              text-decoration-line="initial"
            >
              {t.services}
            </Link>
            <Link
              color="--darkL2"
              font="--base"
              margin="0px 0px 0px 20px"
              md-margin="0"
              md-font="normal 400 24px/1.2 --fontFamily-googlePoppins"
              href="/#team"
              text-decoration-line="initial"
            >
              {t.team}
            </Link>
            <Link
              color="--darkL2"
              font="--base"
              margin="0px 0px 0px 20px"
              md-margin="0"
              md-font="normal 400 24px/1.2 --fontFamily-googlePoppins"
              href="/#contact"
              text-decoration-line="initial"
            >
              {t.contact}
            </Link>
            <Box
              display="inline-flex"
              position="relative"
              background="rgba(10, 25, 47, 0.05)"
              border-radius="100px"
              padding="3px"
              align-items="center"
              grid-gap="2px"
              margin="0px 0px 0px 20px"
              md-margin="0"
              style={{
                backdropFilter: "blur(8px)",
                border: "1px solid rgba(10, 25, 47, 0.08)",
                isolation: "isolate",
                boxShadow: "inset 0 1px 2px rgba(10, 25, 47, 0.05)",
              }}
            >
              {/* Sliding Pill Indicator */}
              <Box
                position="absolute"
                top="3px"
                left={currentLang === "en" ? "3px" : "calc(50% + 1px)"}
                width="calc(50% - 4px)"
                height="calc(100% - 6px)"
                background="#0A192F"
                border-radius="100px"
                z-index="1"
                style={{
                  transition: "left 0.25s cubic-bezier(0.25, 1, 0.5, 1)",
                  boxShadow: "0 2px 8px rgba(10, 25, 47, 0.18)",
                }}
              />
              <Box
                as="button"
                onClick={() => handleSetLang("en")}
                z-index="2"
                padding="6px 14px"
                display="flex"
                align-items="center"
                justify-content="center"
                border="none"
                background="transparent"
                cursor="pointer"
                font="normal 500 12px/1 --fontFamily-googleInter"
                color={currentLang === "en" ? "#FFFFFF" : "#6272A4"}
                style={{
                  transition: "color 0.25s ease",
                  outline: "none",
                  userSelect: "none",
                  WebkitTapHighlightColor: "transparent",
                }}
              >
                EN
              </Box>
              <Box
                as="button"
                onClick={() => handleSetLang("ja")}
                z-index="2"
                padding="6px 14px"
                display="flex"
                align-items="center"
                justify-content="center"
                border="none"
                background="transparent"
                cursor="pointer"
                font="normal 500 12px/1 --fontFamily-googleInter"
                color={currentLang === "ja" ? "#FFFFFF" : "#6272A4"}
                style={{
                  transition: "color 0.25s ease",
                  outline: "none",
                  userSelect: "none",
                  WebkitTapHighlightColor: "transparent",
                }}
              >
                JP
              </Box>
            </Box>
          </Box>
        </Components.QuarklycommunityKitMobileSidePanel>
      </Box>
    </Section>
  )
}

export default Header
